import { useState } from "react";
import styles from "../Phone.module.scss";
import { useVideoSettings } from "../../../contexts/videoSettings/videoSettings.hook";
import { usePrefersReducedMotion } from "../../../contexts/prefersReducedMotion/prefersReducedMotion.hook";
import { useVideoPlayback } from "../../../hooks/useVideoPlayback";
import useResponsive from "../../../hooks/useResponsive";
import { MobileVolume } from "./PhoneSlide/partials/MobileVolume.component";

export const JumpScare = ({ isActive }: { isActive: boolean }) => {
  const { isMobile } = useResponsive();
  const { isMuted } = useVideoSettings();
  const { prefersReducedMotion } = usePrefersReducedMotion();
  const { forceFallback, videoRef } = useVideoPlayback({ isActive });
  const [isMobileMuted, setIsMobileMuted] = useState<boolean>(true);

  return (
    <>
      {prefersReducedMotion || forceFallback ? (
        <img
          src="/phone-slides/stills/7_Phone_Vid_Size_JUMPSCARE.png"
          alt=""
          className={styles.assetStyles}
        />
      ) : (
        <>
          <video
            ref={videoRef}
            autoPlay
            className={styles.assetStyles}
            muted={isMobile ? isMobileMuted : isMuted}
            playsInline
            loop
            poster="/phone-slides/stills/7_Phone_Vid_Size_JUMPSCARE.png"
          >
            <source
              src="/phone-slides/videos/Phone_Vid_Size_JUMPSCARE.mp4"
              type="video/mp4"
            />
          </video>
          {isMobile && (
            <MobileVolume
              isMobileMuted={isMobileMuted}
              setIsMobileMuted={setIsMobileMuted}
              classes="intro-slide"
            />
          )}
        </>
      )}
    </>
  );
};
